






























import { Component, Vue, Prop } from 'vue-property-decorator'


@Component({})
export default class StatsCard extends Vue {
  @Prop(String) icon!: string
  @Prop(String) iconColor!: string;
  @Prop(String) value!: string
  @Prop(String) smallValue!: string
  @Prop(String) subtitle!: string
  @Prop(Boolean) isLoading!: boolean;
  @Prop(String) updatedAt!: string;

  refresh() {
    this.$emit('refresh');
  }
}
